import { ShieldAlert, Flame, HeartPulse, AlertTriangle, MapPin, Car, TrafficCone } from "lucide-react";
import { useTranslation } from "react-i18next";

const emergencyTypes = [
  { type: "security", labelKey: "emergency.security", icon: ShieldAlert, color: "bg-red-500 hover:bg-red-600 border-red-700", textColor: "text-white" },
  { type: "fire", labelKey: "emergency.fire", icon: Flame, color: "bg-orange-500 hover:bg-orange-600 border-orange-700", textColor: "text-white" },
  { type: "medical", labelKey: "emergency.medical", icon: HeartPulse, color: "bg-blue-500 hover:bg-blue-600 border-blue-700", textColor: "text-white" },
  { type: "accident", labelKey: "emergency.accident", icon: Car, color: "bg-yellow-500 hover:bg-yellow-600 border-yellow-700", textColor: "text-white" },
  { type: "banditry", labelKey: "emergency.banditry", icon: AlertTriangle, color: "bg-rose-900 hover:bg-rose-950 border-rose-950", textColor: "text-white" },
  { type: "ecaution", labelKey: "emergency.ecaution", icon: TrafficCone, color: "bg-amber-600 hover:bg-amber-700 border-amber-800", textColor: "text-white" },
  { type: "location_share", labelKey: "emergency.location_share", icon: MapPin, color: "bg-emerald-600 hover:bg-emerald-700 border-emerald-800", textColor: "text-white" },
];

export default function EmergencyTrigger({ onTrigger, mobile }) {
  const { t } = useTranslation();
  if (mobile) {
    return (
      <div
        data-testid="emergency-triggers-mobile"
        className="flex gap-2 overflow-x-auto snap-x snap-mandatory pb-1 -mx-1 px-1 [&::-webkit-scrollbar]:h-1 [&::-webkit-scrollbar-thumb]:bg-gray-300 dark:[&::-webkit-scrollbar-thumb]:bg-gray-600 [&::-webkit-scrollbar-thumb]:rounded-full"
      >
        {emergencyTypes.map(({ type, labelKey, icon: Icon, color, textColor }) => (
          <button
            key={type}
            data-testid={`trigger-${type}-alert`}
            onClick={() => onTrigger(type)}
            className={`emergency-btn shrink-0 basis-20 snap-start flex flex-col items-center justify-center gap-1 py-2.5 ${color} ${textColor} border rounded-sm font-body font-bold text-[10px] uppercase tracking-wider`}
          >
            <Icon className="w-5 h-5" strokeWidth={2} />
            {t(labelKey)}
          </button>
        ))}
      </div>
    );
  }

  return (
    <div data-testid="emergency-triggers">
      <p className="text-xs uppercase tracking-[0.2em] font-bold text-gray-500 mb-3">
        {t("emergency.title")}
      </p>
      <div
        className="flex gap-2 overflow-x-auto snap-x snap-mandatory pb-2 -mx-1 px-1 [&::-webkit-scrollbar]:h-1.5 [&::-webkit-scrollbar-track]:bg-transparent [&::-webkit-scrollbar-thumb]:bg-gray-300 dark:[&::-webkit-scrollbar-thumb]:bg-gray-600 [&::-webkit-scrollbar-thumb]:rounded-full"
        data-testid="emergency-triggers-scroll"
      >
        {emergencyTypes.map(({ type, labelKey, icon: Icon, color, textColor }) => (
          <button
            key={type}
            data-testid={`trigger-${type}-alert`}
            onClick={() => onTrigger(type)}
            className={`emergency-btn shrink-0 basis-24 snap-start aspect-square flex flex-col items-center justify-center gap-2 ${color} ${textColor} border rounded-sm font-body font-bold text-xs uppercase tracking-widest`}
          >
            <Icon className="w-7 h-7" strokeWidth={2} />
            {t(labelKey)}
          </button>
        ))}
      </div>
    </div>
  );
}
